import React, { PropsWithChildren } from "react";
export { LoadingSpinner } from "./loading-spinner";
export { ServerError } from "./server-error";


export const Loader: React.FC<PropsWithChildren<{ loading: boolean }>> =
({ loading, children }) => {
  if (loading) return <>Loading ...</>;

  return <>{children}</>;
};
